__turbopack_context__.v({
  "actionCard": "-bLaka_actionCard",
  "dropModal": "-bLaka_dropModal",
  "isHidden": "-bLaka_isHidden",
  "leftSide": "-bLaka_leftSide",
  "rightSide": "-bLaka_rightSide",
});
